import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "./Sidebar";
import { Link } from "react-router";
import "react-widgets/dist/css/react-widgets.css";

class AuthenticationFailure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            failureMessage: ""
        };
    }

    componentDidMount() {
        // Get from localStorage
        const failureMessage = localStorage.getItem('auth_failure_message');


        // Set to state if it exists
        if (failureMessage) {
            this.setState({ failureMessage });

            // Delete it immediately after using
            localStorage.removeItem('auth_failure_message');
        }
    }


    render() {
        let Mainprops = this.props;
        return (
            <section
                className="back-dashboard widget-sidebar-context mt-3"
                id="my-sidebar-context"
            >
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="panel-heading">
                                <h6 className="mb-0">
                                    {this.props.t("verifyAdhar.adhar_title", {
                                        param: "react",
                                    })}
                                </h6>
                            </div>

                            <div>
                                <div className="tab-content profile-page authen-failure-container pdingspc">
                                    <img alt='authen-failure' src="/images/authen-failure.png" ></img>
                                    <h3 className="authen-failure-title">{this.props.t("verifyAdhar.authen_failed", {
                                        param: "react",
                                    })}</h3>
                                    <p className="authen-failure-content">
                                        {this.state.failureMessage || ""}
                                    </p>
                                    <div className="authen-btn-cont">
                                        <button 
                                        aria-label="Back"
                                        type="button"
                                        className="authen-back-btn wdset1" onClick={() => this.props.router.push("/myaccount")}>{this.props.t("verifyAdhar.backBtn", {
                                            param: "react",
                                        })}</button>
                                        <button 
                                        aria-label="Try Again"
                                        type="button"
                                        className="authen-try-btn wdset" onClick={() => this.props.router.push("/verify-adhar")}>{this.props.t("verifyAdhar.try_agn", {
                                            param: "react",
                                        })}</button>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (store) => {
    return store;
};

export default connect(mapStateToProps)(translate(AuthenticationFailure));
